import { useState } from 'react';

function HivRiskAssessment({ onAssessmentComplete }) {
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState({});

    const questions = [
        {
            id: 1,
            question: 'When was the last time you had a HIV test?',
            options: [
                { value: 'never', label: 'Never' },
                { value: 'lt_3', label: 'Less than 3 months ago' },
                { value: '3_6', label: '3-6 months ago' },
                { value: '7_12', label: '7-12 months ago' },
                { value: 'gt_12', label: 'More than a year ago' },
            ]
        },
        {
            id: 2,
            question: 'How often do you have unprotected sex?',
            options: [
                { value: 'never', label: 'Never' },
                { value: 'rarely', label: 'Rarely' },
                { value: 'sometimes', label: 'Sometimes' },
                { value: 'often', label: 'Often' },
                { value: 'always', label: 'Always' },
            ]
        }
    ];

    const handleAnswer = (value) => {
        const newAnswers = { ...answers, [questions[currentQuestion].id]: value };
        setAnswers(newAnswers);

        if (currentQuestion < questions.length - 1) {
            setCurrentQuestion(currentQuestion + 1);
            return;
        }

        // Assessment complete: evaluate qualification rules
        // Qualify if test timing is one of: 3-6, 7-12, gt_12 OR if unprotected sex frequency is one of rarely/sometimes/often/always
        const testTiming = newAnswers[1];
        const unprotectedFreq = newAnswers[2];

        const testTimingQualifies = ['3_6', '7_12', 'gt_12'].includes(testTiming);
        const unprotectedQualifies = ['rarely', 'sometimes', 'often', 'always'].includes(unprotectedFreq);

    // All users qualify regardless of answers
    const qualifiesForKit = true;
    const finalRiskScore = 1;
        onAssessmentComplete(qualifiesForKit, finalRiskScore, newAnswers);
    };

    const resetAssessment = () => {
        setCurrentQuestion(0);
        setAnswers({});
    };

    return (
        <div className="px-8 pt-6 pb-8 mb-4">
            <div className="mb-6">
                <h3 className="text-2xl font-bold text-gray-700 mb-4">
                    HIV Risk Assessment
                </h3>
                <p className="text-lg text-gray-600 mb-4">
                    Please answer the following questions honestly.
                </p>
                <div className="w-full bg-gray-200 rounded-full h-2.5 mb-6">
                    <div 
                        className="bg-teal-600 h-2.5 rounded-full transition-all duration-300" 
                        style={{width: `${((currentQuestion + 1) / questions.length) * 100}%`}}
                    ></div>
                </div>
                <p className="text-sm text-gray-500 mb-6">
                    Question {currentQuestion + 1} of {questions.length}
                </p>
            </div>

            <div className="mb-8">
                <h4 className="text-xl font-semibold text-gray-700 mb-6 leading-relaxed">
                    {questions[currentQuestion].question}
                </h4>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {questions[currentQuestion].options.map(opt => (
                        <button
                            key={opt.value}
                            onClick={() => handleAnswer(opt.value)}
                            className="btn btn-lg rounded-none bg-teal-600 hover:bg-teal-700 text-white font-bold py-4 px-6 focus:outline-none focus:shadow-outline transition-colors"
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="flex justify-between items-center">
                <button 
                    onClick={resetAssessment}
                    className="btn btn-sm rounded-none bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                >
                    Start Over
                </button>
                <div className="text-sm text-gray-500">
                    All information is confidential.
                </div>
            </div>
        </div>
    );
}

export default HivRiskAssessment;